import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './ParagraphLoader.module.scss';

const SkeletonBlock = ({ className, height }) => (
  <div className={className}>
    <Skeleton borderRadius={6} height={height} />
  </div>
);

const ParagraphLoader = ({ height }) => (
  <>
    <SkeletonBlock className={styles.paragraphLine1} height={height} />
    <SkeletonBlock className={styles.paragraphLine2} height={height} />
    <SkeletonBlock className={styles.paragraphLine3} height={height} />
  </>
);

export default ParagraphLoader;
